// extracted by mini-css-extract-plugin
export default {"wrap":"BodyTooltip_wrap__-SEWJ","title":"BodyTooltip_title__tTgAC","notifWrap":"BodyTooltip_notifWrap__R6-2H","name":"BodyTooltip_name__tkrNT","icon":"BodyTooltip_icon__NrqKi"};